<mat-card>
  <mat-card-content>
    <mat-card-title>
      Settore Scientifico

      <div fxFlex="60%;" fxFlex.xs="100%" align="right">
        <button mat-raised-button
                color="primary" (click)="btnAggiungiModifica(-1)" style="float: right">
          Nuovo
        </button>
        </div>


        <div fxFlex="20%;" fxFlex.xs="100%" align="right">
          <button mat-raised-button color="primary">
            <a style="color:white" csvLink delimiter=";" [data]="lstElenco" filename="SettoreScientifico">Esporta CSV</a>
          </button>
        </div>
    </mat-card-title>
  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-content>

    <div fxLayout="row wrap">
      <div fxFlex.gt-sm="50%">
        <mat-form-field class="full-width">
          <input matInput
                 placeholder="Filtra"
                 [(ngModel)]="txtFiltra"
                 id="txtFiltra"
                 value=""
                 (keyup)='updateFilter($event)'>
        </mat-form-field>
      </div>
    </div>

    <ngx-datatable #grdSettoreScientifico
                   [rows]="lstElenco"
                   [columnMode]="'flex'"
                   [headerHeight]="50"
                   [footerHeight]="50"
                   [limit]="30"
                   [rowHeight]="'auto'">

      <ngx-datatable-column name="" [flexGrow]="0.5">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div style="float:left">
            <button mat-icon-button mat-sm-button color="primary"
                    class="mr-1"
                    (click)="btnAggiungiModifica(row.idSettoreScientifico)"
                    matTooltip="Modifica">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
 
      <ngx-datatable-column name="Settore Scientifico"
                            [flexGrow]="2"
                            [sortable]="true"
                            prop="SettoreScientificoDescrizione">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.SettoreScientificoDescrizione }}
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Visibile"
                            [flexGrow]="1"
                            [sortable]="true"
                            prop="Visibile">
        <ng-template let-row="row" ngx-datatable-cell-template>
          {{ row?.Visibile === 1 ? 'Si' : 'No'}}
        </ng-template>
      </ngx-datatable-column>

    </ngx-datatable>

  </mat-card-content>
</mat-card>



